<section class="topup-section container">
  <div class="row align-center">
    <div class="value-wrapper">

      <div class="row align-center">

        <div class="topup-container text-center">

          <div class="topup-value inner-wrapper">
            <form [formGroup]="formGroup" (ngSubmit)="onFormSubmit()">
              <div class="input-with-floating-label main-phone-number"
                [ngClass]="{'error' : isMsisdnInputInvalid()}">
                <input class="input-phone input-phone-main" type="tel" id="topups-phone-2" formControlName="msisdn"
                  #msisdnInput autocomplete="tel" >
                  <label for="topups-phone-2" i18n="insertPhoneNumber" class="phone-label">Wpisz numer telefonu</label>
                  @if (isMsisdnInputInvalid()) {
                    <small
                    role="alert" class="form-message">{{ getMsisdnErrorMsg() }}</small>
                  }
                </div>
                <h2 class="text-left no-margin" i18n="Amount">Za ile chcesz doładować?</h2>

                <div class="tab-content-wrapper">

                  <amount-picker [formGroup]="formGroup"></amount-picker>

                  <gift-banner [formGroup]="formGroup" hidden></gift-banner>

                </div>

                <button type="submit" class="button medium" i18n="@@goButton">Dalej<span class="icon icon-chevron-right"></span>
              </button>
            </form>

            @if (!this.restService.isVirgin()) {
              <p class="payment-info text-center no-margin" i18n="@@PayUInformation">
              Doładowania Play są realizowane <br class="show-for-small-only">za pośrednictwem
              <img class="logo" src="assets/images/logo_payu.svg" alt="Logo PayU" style="width: 32px; height: 16px">
            </p>
            }
            @if (this.restService.isVirgin()) {
              <p class="payment-info text-center no-margin" i18n="@@PayUInformationVirgin" [ngStyle]="{'width': isPl() ? 'max-content' : 'unset' }">
              Doładowania Virgin Mobile są realizowane <br class="show-for-small-only">za pośrednictwem
              <img class="logo" src="assets/images/logo_payu.svg" alt="Logo PayU" style="width: 32px; height: 16px">
            </p>
            }

          </div>
        </div>

      </div>

    </div>
  </div>
</section>


